/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

//<custom-head>
import { ArticleTaxDto } from './article-tax-dto';
//</custom-head>

export class ClearanceCaseRowTaxDto {
  public id: number = undefined;
  public index: number = undefined;
  public countryCode: string = undefined;
  public additionalTaxTypeId: number = undefined;
  public additionalTaxTypeCode: string = undefined;
  public description: string = undefined;
  public overrideCalculation: boolean;
  public amount: number = undefined;
  public taxBase: number = undefined;
  public rate: number = undefined;
  public measurementUnitId: number = undefined;
  public sequence: number = undefined;

  //<custom-body>
  fromArticle(article: ArticleTaxDto): ClearanceCaseRowTaxDto {
    this.index = article.index;
    this.measurementUnitId = article.measurementUnitId;
    this.sequence = article.sequence;
    this.rate = article.rate;
    this.additionalTaxTypeId = article.additionalTaxTypeId;
    this.countryCode = article.countryCode;

    return this;
  }
  //</custom-body>
}
